import { ArrowRight } from 'components/Icons'
import React from 'react'
import { BreadcrumbContainer, BreadcrumbItem } from './Breadcrumb.style'

const Breadcrumb = ({ data }) => {
  const length = data.length
  return (
    <BreadcrumbContainer>
      {data
        ? data.map((item, index) => {
            let icon = ''
            if (index !== length - 1) {
              icon = <ArrowRight width="4" height="6.9" color="black4" />
            }
            return (
              <BreadcrumbItem
                key={index}
                to={item.to}
                className={index === length - 1 ? 'active' : ''}
              >
                {item.name}
                <span className="breadcrumb-icon">{icon}</span>
              </BreadcrumbItem>
            )
          })
        : null}
    </BreadcrumbContainer>
  )
}

export default Breadcrumb
